export class TipoReuniaoModel {

  constructor(
    public tpReuniao?: string,
    public dsReuniao?: string,
    public dirAnexosIntranet?: string,
    public dirAnexosInternet?: string
  ) {
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/tipo-reuniao.model.ts